import styles from './EnrollmentAccessBadge.module.css';

export default function EnrollmentAccessBadge({ student, detail = false }) {
    if (student.access_mode !== 'limited') return detail ? null : <span className={`${styles.badge} ${styles.full}`}>Accesso completo</span>;
    const count = Array.isArray(student.allowed_lesson_ids) ? student.allowed_lesson_ids.length : null;
    return <span className={styles.badge}>
        Accesso limitato{detail && count !== null && ` · ${count} ${count === 1 ? 'lezione abilitata' : 'lezioni abilitate'}`}
    </span>;
}
